export default __webpack_public_path__ + "static/media/Playing Danndiya_1024.f90c5519.png";